<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="#/impressum">
              Impressum
            </a>
          </li>
          <li>
            <a href="#/datenschutz">
              Datenschutzerklärung
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, by
        <a href="#/" target="_blank" style="color: rgb(225, 100, 205)">Balkon &amp; Zaun-Profi Leibhammer + Rietz GmbH</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
